import * as React from "react"
import type { SVGProps } from "react"

export const PlayCircleFilledIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m10.794 15.365 4.356-2.798a.64.64 0 0 0 .321-.566.64.64 0 0 0-.321-.568l-4.356-2.798a.62.62 0 0 0-.69-.037.64.64 0 0 0-.354.604v5.596q0 .41.354.604.354.195.69-.037m1.208 6.135a9.3 9.3 0 0 1-3.706-.748 9.6 9.6 0 0 1-3.016-2.03 9.6 9.6 0 0 1-2.032-3.016 9.25 9.25 0 0 1-.748-3.704q0-1.971.748-3.706a9.6 9.6 0 0 1 2.03-3.016 9.6 9.6 0 0 1 3.016-2.032 9.25 9.25 0 0 1 3.704-.748q1.972 0 3.706.748a9.6 9.6 0 0 1 3.017 2.03 9.6 9.6 0 0 1 2.03 3.016 9.25 9.25 0 0 1 .749 3.704 9.3 9.3 0 0 1-.748 3.706 9.6 9.6 0 0 1-2.03 3.017 9.6 9.6 0 0 1-3.016 2.03 9.25 9.25 0 0 1-3.704.749"
    ></path>
  </svg>
)
